// TODO: Replace clientId with the actual Entra ID app registration client ID before production release
export default {
    scorecardApiUrl: 'https://ep-app-Scorecard-API-prod-nzn-hscga9a9hqbwf0af.a03.azurefd.net',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 2,
    sampleRate: 0.5,
     sentry: {
        dsn: "https://ec930212c4ed37a625a765b2db5fd85a@o4509346579677184.ingest.de.sentry.io/4511255050453072",
    },
};
